import "./inboxssr.js";

function callInitFunction(el) {
  // calls init functions on the given element.
  // needsInit should be the name of the function to call. These functions
  // should be registered in `window`.
  //
  // It will remove `data-needs-init` and add `data-ran-init` attribute to
  // prevent multiple runs of the same init function on the element.
  function getProp(obj, desc) {
    var arr = desc.split(".");
    while (arr.length && (obj = obj[arr.shift()]));
    return obj;
  }
  function reportUnknownInitHook(fname) {
    const reported = new Set((el.dataset.initUnknownHooks || "").split(","));
    if (reported.has(fname)) return;
    reported.add(fname);
    el.dataset.initUnknownHooks = [...reported].filter(Boolean).join(",");
    window.console?.warn?.(`Unknown data-needs-init hook: ${fname}`, el);
    window.dispatchEvent(new CustomEvent("smaac:unknown-init-hook", {
      detail: { element: el, hook: fname },
    }));
  }
  if (el.dataset.needsInit !== undefined) {
    const fnames = el.dataset.needsInit
    delete el.dataset.needsInit
    el.dataset.needsInitStarted = ''
    el.dataset.needsInitCompleted = ''
    fnames.split(',').map((fname) => {
      el.dataset.needsInitStarted += ',' + fname
      let fn = getProp(window, fname)
      if (fn === undefined) {
        fn = getProp(el, fname);
      }
      if (typeof fn === "function") {
        fn(el);
      } else {
        reportUnknownInitHook(fname);
      }
      el.dataset.needsInitCompleted += ',' + fname
    })
  }
};

export function registerInitFunctions() {
  Array.prototype.slice.call(document.querySelectorAll(
    '[data-needs-init]')).map(callInitFunction)
};

window.testNeedsInit = function (el) {
  el.innerHTML = 'Ok'
};

// Width is data-driven per row, so it cannot be a static utility class; set it
// from data-perc here to keep templates free of inline style attributes.
window.setBarWidth = function (el) {
  if (el.dataset.perc !== undefined) {
    el.style.width = el.dataset.perc + '%'
  }
};

function bindSsrModalButton(el, actionName) {
  var modalName = el && el.dataset ? el.dataset.modalTarget : '';
  if (!modalName || el.dataset.modalAction) return;
  el.addEventListener('click', function () {
    var action = window[actionName];
    if (typeof action === 'function') {
      action(modalName);
    }
  });
}

// Tabbed "linked records" strip (ssr/views/linked_records.html).
//
// Collapsed by default: a tab opens the shared body below the bar, another tab
// switches the body, the active tab closes it again. Generic and data-driven,
// so no page ever needs its own copy; it lives here rather than in a page
// bundle because the strip is meant to be adopted form by form.
window.ssrLinkedRecords = function (root) {
  if (!root || root.dataset.linkedRecordsBound === '1') return;
  root.dataset.linkedRecordsBound = '1';

  function apply(key) {
    root.querySelectorAll('[data-linked-tab]').forEach(function (tab) {
      var active = key !== null && tab.dataset.linkedTab === key;
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.classList.toggle('bg-indigo-600', active);
      tab.classList.toggle('text-white', active);
      tab.classList.toggle('text-gray-500', !active);
    });
    root.querySelectorAll('[data-linked-panel]').forEach(function (panel) {
      panel.classList.toggle('hidden', panel.dataset.linkedPanel !== key);
    });
    root.dataset.linkedActive = key === null ? '' : key;
  }

  root.addEventListener('click', function (event) {
    var tab = event.target.closest ? event.target.closest('[data-linked-tab]') : null;
    if (!tab || !root.contains(tab)) return;
    var key = tab.dataset.linkedTab;
    apply(root.dataset.linkedActive === key ? null : key);
  });

  apply(null);
};

window.openSsrModal = function (el) {
  bindSsrModalButton(el, 'openModal');
};

window.closeSsrModal = function (el) {
  bindSsrModalButton(el, 'closeModal');
};

// data-needs-init resolves hook names through window, so this initializer must be global.
window.initCommentModal = function (el) {
  if (!el || el.dataset.commentModalInitialized === 'true') return;
  el.dataset.commentModalInitialized = 'true';
  el.addEventListener('htmx:afterSettle', function () {
    if (typeof window.closeModal === 'function') window.closeModal('blank');
  });
};

// Voucher-copy controls can be replaced through HTMX/OOB swaps, so delegate
// their modal actions instead of attaching one-time listeners to each control.
document.addEventListener('click', function (event) {
  var trigger = event.target.closest('[data-modal-action][data-modal-target]');
  if (!trigger) return;

  event.preventDefault();
  event.stopPropagation();

  var modalName = trigger.dataset.modalTarget;
  if (trigger.dataset.modalAction === 'open' && typeof window.openModal === 'function') {
    window.openModal(modalName);
  }
  if (trigger.dataset.modalAction === 'close' && typeof window.closeModal === 'function') {
    window.closeModal(modalName);
  }
});

window.ctrlClickNewTab = function (el) {
  el.addEventListener('click', function (e) {
    if (!(e.ctrlKey || e.metaKey)) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    var url = el.getAttribute('hx-get');
    if (!url) return;

    var hxVals = el.getAttribute('hx-vals') || '';
    var raw = hxVals.replace(/^js:/, '');
    var params = [];
    raw.replace(/'([^']+)'\s*:\s*'([^']*)'/g, function (_, k, v) {
      params.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
    });

    var tokenEl = document.querySelector('[name="apitoken"]');
    if (tokenEl) params.push('apitoken=' + encodeURIComponent(tokenEl.value));

    var sep = url.indexOf('?') === -1 ? '?' : '&';
    window.open(url + sep + params.join('&'), '_blank');
  }, true);
};

// init.js
if ('serviceWorker' in navigator) {
  let registration = null;

  function checkForWaitingServiceWorker() {
    if (registration && registration.waiting) {
      console.log('New service worker is waiting');
      document.dispatchEvent(new CustomEvent('swUpdated', { detail: registration }));
    }
  }
  
  window.addEventListener("load", function() {
    navigator.serviceWorker.register('/sw.js')
      .then((reg) => {
        registration = reg;
        console.log("Service Worker Registered with scope:", reg.scope);
        const rawToken = window.localStorage.getItem("apitoken") 
        const userToken = rawToken ? rawToken.slice(0, 20) : null;
        if (userToken && reg.active) {
          reg.active.postMessage({ type: 'SET_TOKEN', token: userToken });
        }
        const watchInstallingWorker = () => {
          const worker = reg.installing;
          if (worker) {
            worker.addEventListener('statechange', checkForWaitingServiceWorker);
          }
          checkForWaitingServiceWorker();
        };
        reg.addEventListener('updatefound', watchInstallingWorker);
        watchInstallingWorker();
      })
      .catch((error) => {
        console.error("Service Worker Registration Failed:", error);
      });
  });
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (navigator.serviceWorker.controller) {
      const rawToken = window.localStorage.getItem("apitoken")
      const userToken = rawToken ? rawToken.slice(0, 20) : null;
      if (userToken) {
        navigator.serviceWorker.controller.postMessage({ type: 'SET_TOKEN', token: userToken });
      }
    }
  });
} else {
  console.warn("Service Workers are not supported in this browser.");
}


// --------
// Ensure init functions run on both initial page load and after any HTMX swap.
// Important: do NOT rely on `window.onload` here, because many bundles assign to
// it and can overwrite each other.
(() => {
  // Catch HTMX swaps even if they happen before DOMContentLoaded.
  document.addEventListener('htmx:afterSettle', function () {
    registerInitFunctions();
  });

  const runInitial = () => registerInitFunctions();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runInitial, { once: true });
  } else {
    runInitial();
  }
})()
